<template>
  <main-container>
    <a-card title="用户基本信息" style="margin-bottom: 24px">
      <a-skeleton :loading="detailloading" active>
        <a-descriptions bordered style="margin-bottom: 24px">
          <a-descriptions-item label="会员ID">
            {{ user.user_id }}
          </a-descriptions-item>
          <a-descriptions-item label="会员昵称">
            {{ user.username }}
          </a-descriptions-item>
          <a-descriptions-item label="会员等级">
            <template v-if="!setUserLevel">
              <!--              {{ user.user_level }}-->
              <span v-if="user.user_level == 0">销售价格</span>
              <span v-if="user.user_level == 1">一级会员价格</span>
              <span v-if="user.user_level == 2">二级会员价格</span>
              <span v-if="user.user_level == 3">三级会员价格</span>
              <span v-if="user.user_level == 4">四级会员价格</span>
              <span v-if="user.user_level == 5">五级会员价格</span>
              <a @click="handleSetUserLevelClick" style="margin-left: 12px">修改</a>
            </template>
            <template v-else>
              <a-select
                style="width: 150px; margin-right: 12px"
                :options="userLevelOptions"
                v-model="userLevel"
              ></a-select>
              <a-button style="margin-right: 12px" type="primary" @click="handleSetUserLevel">保存 </a-button>
              <a-button @click="handleSetUserLevelCancel">取消</a-button>
            </template>
          </a-descriptions-item>
          <a-descriptions-item label="手机号码">
            {{ user.phone }}
          </a-descriptions-item>
          <a-descriptions-item label="注册邮箱">
            {{ user.email }}
          </a-descriptions-item>
          <a-descriptions-item label="注册时间">
            {{ user.reg_time }}
          </a-descriptions-item>
          <a-descriptions-item label="公司/个体">
            <span v-if="user.type == 1">个体</span>
            <span v-if="user.type == 2">公司</span>
          </a-descriptions-item>
          <a-descriptions-item label="CIF/NIF">
            {{ user.tax_code }}
          </a-descriptions-item>
          <a-descriptions-item label="公司名称">
            {{ user.company }}
          </a-descriptions-item>
          <a-descriptions-item label="姓">
            {{ user.lname }}
          </a-descriptions-item>
          <a-descriptions-item label="名">
            {{ user.fname }}
          </a-descriptions-item>
          <a-descriptions-item label="城市">
            {{ user.city }}
          </a-descriptions-item>
          <a-descriptions-item label="邮编">
            {{ user.postcode }}
          </a-descriptions-item>
          <a-descriptions-item label="地址">
            {{ user.address }}
          </a-descriptions-item>
        </a-descriptions>
        <a-collapse class="address-list">
          <a-collapse-panel key="1" :header="'发货地址(' + fromAddressList.length + ')'">
            <a-list :data-source="fromAddressList">
              <a-list-item slot="renderItem" slot-scope="item">
                {{ item.full_name }} , {{ item.phone }}, {{ item.country_name }}, {{ item.city }}, {{ item.address }},
                {{ item.address1 }},
                {{ item.post_code }}
              </a-list-item>
            </a-list>
          </a-collapse-panel>
          <a-collapse-panel key="2" :header="'收货地址(' + shippingAddressList.length + ')'">
            <a-list :data-source="shippingAddressList">
              <a-list-item slot="renderItem" slot-scope="item">
                {{ item.full_name }} , {{ item.phone }}, {{ item.country_name }}, {{ item.city }}, {{ item.address }},
                {{ item.address1 }},
                {{ item.post_code }}
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-skeleton>
    </a-card>
    <a-card title="会员充值">
      <p>账户余额：€{{ user.balance }}</p>
      <p>
        账户欠款：
        <span style="color: red;margin-right: 12px;">€{{ parseInt(user.amount_owed) / 100 }}</span>
        <a-button type="danger" :loading="depositing" @click="dialog.Amount = true">还款 </a-button>
      </p>
      <p>
        充值金额：
        <a-input-number :step="0.1" style="width: 120px" v-model="amount" />
        <a-button style="margin-left: 12px" type="primary" :loading="depositing" @click="handleDepositClick"
          >充值
        </a-button>
      </p>
      <p>
        手动扣款金额：
        <a-input-number style="width: 120px" :step="0.1" v-model="amount_2" />
        <a-button style="margin-left: 12px" type="primary" :loading="depositing" @click="handleDepositClick2">
          管理员扣款</a-button
        >
      </p>
      <p>
        充值消费记录：
        <a-radio-group :value="checkedBillsType" @change="handleBillsTypeChange">
          <a-radio-button value="">
            全部记录
          </a-radio-button>
          <a-radio-button value="1">
            充值记录
          </a-radio-button>
          <a-radio-button value="2">
            消费记录
          </a-radio-button>
          <a-radio-button value="3">
            还款记录
          </a-radio-button>
          <a-radio-button value="4">
            账单信息
          </a-radio-button>
          <a-radio-button value="5">
            订单信息
          </a-radio-button>
        </a-radio-group>
      </p>
      <a-table
        row-key="id"
        :columns="billsColumns"
        :data-source="billsDataSource"
        :pagination="billsPagination"
        :loading="gettingBills"
        @change="handleBillsTableChange"
      >
        <template slot="system_id" slot-scope="text, record" v-if="checkedBillsType == 2">
          <router-link :to="{ name: $routeName.orderDetail, query: { id: record.lid } }">
            <p>{{ record.system_id }}</p>
          </router-link>
        </template>
        <template slot="owed_amount" slot-scope="text">
          <span style="color: red;">{{ text }}</span>
        </template>
        <template slot="download" slot-scope="item">
          <span class="download" @click="downloadOrderId = item.id">下载</span>
        </template>
        <span slot="amount" slot-scope="text, record" :class="{ highlight: record.type === '1' }">
          <template v-if="record.type === '1'">+</template>
          <template v-if="record.type !== '1'">-</template>
          {{ text }} €
        </span>
      </a-table>
    </a-card>
    <AmountOwedModel
      @close="dialog.Amount = false"
      :show="dialog.Amount"
      @success="
        getUserDetail();
        checkedBillsType = 3;
        handleBillsTypeChange({ target: { value: 3 } });
      "
    />
    <PDF :orderId="downloadOrderId" @done="downloadOrderId = undefined" />
  </main-container>
</template>

<script>
import Member from '@/api/member';
import Order from '@/api/order';
import PDF from '@/components/pdf/pdf.vue';

import AmountOwedModel from './AmountOwedModel.vue';
var billsCol = [
  {
    dataIndex: 'num',
    title: '序号',
    width: 90,
  },
  {
    dataIndex: 'system_id',
    title: '订单号',
  },
  {
    dataIndex: 'create_time',
    title: '日期',
  },
  {
    dataIndex: 'user_id',
    title: '会员ID',
  },
  {
    dataIndex: 'desc',
    title: '描述',
  },
  {
    dataIndex: 'amount',
    title: '充值/消费',
    scopedSlots: { customRender: 'amount' },
  },
  {
    dataIndex: 'balance',
    title: '当前余额',
  },
  {
    dataIndex: 'pay_method',
    title: '支付方式',
  },
  {
    dataIndex: 'status',
    title: '状态',
    customRender: text => {
      return { 0: '取消', 1: '成功' }[text];
    },
  },
];
var repayCol = [
  {
    dataIndex: 'num',
    title: '序号',
    width: 90,
  },
  {
    dataIndex: 'create_time',
    title: '操作时间',
  },
  {
    // dataIndex: 'create_time',
    title: '操作员',
  },
  {
    dataIndex: 'owed_amount',
    title: '当前欠款',
    scopedSlots: { customRender: 'owed_amount' },
  },
  {
    dataIndex: 'amount',
    title: '操作金额',
  },
  {
    dataIndex: 'pay_method',
    title: '收款方式',
  },
  {
    dataIndex: 'bank',
    title: '到账银行',
  },
  {
    dataIndex: 'arrival_time',
    title: '到账日期',
  },
  {
    dataIndex: 'remark',
    title: '备注',
  },
];
var billsInfo = [
  {
    dataIndex: 'count_sn',
    title: '账单编号',
  },
  {
    dataIndex: 'total_amount',
    title: '总金额',
  },
  {
    dataIndex: 'create_time',
    title: '创建时间',
  },
  {
    key: 'download',
    title: '下载',
    scopedSlots: { customRender: 'download' },
  },
];
var orderInfo = [
  {
    title: '订单编号',
    dataIndex: 'order_id',
    width: 50,
  },
  {
    title: '订单来源',
    dataIndex: 'source',
    width: 50,
  },
  {
    title: '发件人',
    dataIndex: 'username',
    width: 50,
  },
  {
    title: '物流单号',
    dataIndex: 'line_no',
    scopedSlots: { customRender: 'lineNo' },
    width: 50,
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    width: 50,
  },
  {
    title: '寄件城市',
    dataIndex: 'send_city',
    width: 50,
  },
  {
    title: '收件城市',
    dataIndex: 'receive_city',
    width: 50,
  },
  {
    title: '物流路线',
    dataIndex: 'service',
    width: 50,
  },
  {
    title: '处理状态',
    dataIndex: 'status_text',
    width: 50,
  },
  {
    title: '订单时间',
    dataIndex: 'create_time',
    width: 50,
  }
];
export default {
  name: 'MemberIncomeDetail',
  components: {
    AmountOwedModel,
    PDF,
  },
  data() {
    return {
      dialog: {
        Amount: false,
      },
      downloadOrderId: undefined,
      id: undefined,
      user: {},
      amount: undefined,
      amount_2: '',
      depositing: false,
      detailloading: false,
      fromAddressList: [],
      shippingAddressList: [],
      checkedBillsType: '',
      gettingBills: false,
      billsColumns: billsCol,
      billsDataSource: [],
      billsPagination: {
        current: 1,
        pageSize: 20,
      },
      setUserLevel: false,
      userLevelOptions: [
        {
          label: '销售价格',
          value: 0,
        },
        {
          label: '一级会员价格',
          value: 1,
        },
        {
          label: '二级会员价格',
          value: 2,
        },
        {
          label: '三级会员价格',
          value: 3,
        },
        {
          label: '四级会员价格',
          value: 4,
        },
        {
          label: '五级会员价格',
          value: 5,
        },
      ],
      userLevel: undefined,
      userLevelName: '',
      settingUserLevel: false,
    };
  },

  mounted() {
    this.id = this.$route.query.id;

    if (this.id) {
      this.getUserDetail();

      Member.userAddressList({
        user_id: this.id,
        type: 1,
      }).then(({ data }) => {
        this.fromAddressList = data;
      });

      Member.userAddressList({
        user_id: this.id,
        type: 2,
      }).then(({ data }) => {
        this.shippingAddressList = data;
      });

      this.getBills({
        page: 1,
        page_limit: 20,
      });
    }
  },

  methods: {
    handleBillsTableChange(pagination) {
      console.log('------------------------');
      this.getBills({
        type: this.checkedBillsType,
        page: pagination.current,
        page_limit: pagination.pageSize,
      });
    },

    handleBillsTypeChange(e) {
      this.checkedBillsType = e.target.value;
      if (e.target.value == 3) {
        //还款记录
        this.billsColumns = repayCol;
        this.getRepayBills({
          type: this.checkedBillsType,
          page_limit: this.billsPagination.pageSize,
          ...this.billsPagination,
        });
      } else if (e.target.value == 4) {
        // 账单信息
        this.billsColumns = billsInfo;
        this.getBillsInfo({
          type: this.checkedBillsType,
          page_limit: this.billsPagination.pageSize,
          ...this.billsPagination,
        });
      } else if (e.target.value == 5) {
        this.billsColumns = orderInfo;
        this.getOrderInfo({
          type: this.checkedBillsType,
          page_limit: this.billsPagination.pageSize,
          ...this.billsPagination,
        });
      } else {
        // 充值/消费记录
        this.billsColumns = billsCol;
        this.getBills({
          type: this.checkedBillsType,
          page_limit: this.billsPagination.pageSize,
          ...this.billsPagination,
        });
      }
    },

    handleDepositClick() {
      if (!this.amount) {
        this.$message.error('请输入充值金额');
        return;
      }

      this.deposit();
    },
    handleDepositClick2() {
      console.log('测试');
      if (!this.amount_2) {
        this.$message.error('请输入扣款金额');
        return;
      }
      this.deposit2();
    },
    handleSetUserLevelClick() {
      for (var i = 0; i < this.userLevelOptions.length; i++) {
        if (this.userLevelOptions[i].value == this.user.user_level) {
          this.userLevelName = this.userLevelOptions[i].label;
        }
      }
      this.userLevel = this.user.user_level;
      this.setUserLevel = true;
    },

    handleSetUserLevelCancel() {
      this.userLevel = undefined;
      this.setUserLevel = false;
    },

    handleSetUserLevel() {
      this.updateUserLevel();
    },

    async updateUserLevel() {
      this.settingUserLevel = true;
      try {
        const { status } = await Member.setUserLevel({
          user_id: this.id,
          level: this.userLevel,
        });

        if (status === 'success') {
          this.$message.success('修改成功');
          this.user.user_level = this.userLevel;
          this.handleSetUserLevelCancel();
        }
      } finally {
        this.settingUserLevel = false;
      }
    },

    async deposit() {
      try {
        this.depositing = true;
        const { status, msg } = await Member.userDeposit({
          user_id: this.id,
          amount: this.amount,
        });

        if (status === 'success') {
          this.getUserDetail().then();

          if (this.checkedBillsType === '' || this.checkedBillsType === '1') {
            this.getBills({
              page: 1,
            }).then();
          }

          this.$message.success('充值成功');
        } else {
          this.$message.error(msg);
        }
      } finally {
        this.depositing = false;
      }
    },
    async deposit2() {
      try {
        this.depositing = true;
        const { status, msg } = await Member.subtractAmount({
          user_id: this.id,
          amount: this.amount_2,
        });

        if (status === 'success') {
          this.getUserDetail().then();

          if (this.checkedBillsType === '' || this.checkedBillsType === '1') {
            this.getBills({
              page: 1,
            }).then();
          }

          this.$message.success('扣款成功');
        } else {
          this.$message.error(msg);
        }
      } finally {
        this.depositing = false;
      }
    },

    async getUserDetail() {
      try {
        this.detailloading = true;
        const { data } = await Member.userDetail({
          user_id: this.id,
        });

        this.user = data;
      } finally {
        this.detailloading = false;
      }
    },

    async getBills(params) {
      this.gettingBills = true;
      try {
        const {
          data: { list, total_items: total, page: current, page_limit: pageSize },
        } = await Member.userBills({
          user_id: this.id,
          ...params,
        });
        this.billsDataSource = list;
        this.billsPagination = {
          total,
          current,
          pageSize,
        };
      } finally {
        this.gettingBills = false;
      }
    },
    async getRepayBills(params) {
      this.gettingBills = true;
      try {
        const {
          data: { list, total_items: total, page: current, page_limit: pageSize },
        } = await Member.repayBills({
          user_id: this.id,
          ...params,
        });
        this.billsDataSource = list;
        this.billsPagination = {
          total,
          current,
          pageSize,
        };
      } finally {
        this.gettingBills = false;
      }
    },
    async getBillsInfo(params) {
      this.gettingBills = true;
      try {
        const {
          data: { list, total_items: total, page: current, page_limit: pageSize },
        } = await Member.billsInfo({
          user_id: this.id,
          ...params,
        });
        this.billsDataSource = list;
        this.billsPagination = {
          total,
          current,
          pageSize,
        };
      } finally {
        this.gettingBills = false;
      }
    },
    async getOrderInfo(params) {
      this.gettingBills = true;
      try {
        const {
          data: { list, total_items: total, page: current, page_limit: pageSize },
        } = await Order.orderList({
          user_id: this.id,
          ...params,
        });
        this.billsDataSource = list;
        this.billsPagination = {
          total,
          current,
          pageSize,
        };
      } finally {
        this.gettingBills = false;
      }
    },
  },
  watch: {
    // checkedBillsType(e) {
    //   // console.log('切换', e);
    //   // if (e == 2) {
    //   //   this.billsColumns[4].title = '消费';
    //   // } else {
    //   //   this.billsColumns[4].title = '充值';
    //   // }
    //   // for (var i=0;i<this.billsColumns.length;i++){
    //   //   console.log('this.billsColumns',this.billsColumns[i])
    //   // } ;
    // },
  },
};
</script>

<style scoped lang="less">
.address-list {
  ::v-deep {
    .ant-collapse-content > .ant-collapse-content-box {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.highlight {
  color: #f5222d;
}
.download {
  color: blue;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
